//
//
//
//
//
//
//
//

export default {
  name: 'app',
  created () {
    this.$navigation.on('back', (to, from) => {
      if (from.route.query.loginBackNum && (from.route.query.loginBackNum === -2 || from.route.query.loginBackNum === '-2')) {
        this.$router.go(-1)
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/App.vue